// @vendors
import { put, takeLatest, call, } from 'redux-saga/effects';
import get from 'lodash/get';

// @Services
import {
  getLocations,
  getProvinces,
  getUserById,
  getUserInfo,
  getUserRegisters,
  getUserStatusById,
  getUsers,
  updateUserInfo,
} from './users.services';

// @Actions
import {
  REQUEST_STARTED,
  REQUEST_FINISHED,
  REQUEST_FAILURE
} from '../app/app.actionTypes';
import {
  REQUEST,
  REQUEST_BY_ID,
  REQUEST_BY_ID_SUCCESS,
  REQUEST_INFO,
  REQUEST_INFO_SUCCESS,
  REQUEST_LOCATIONS,
  REQUEST_LOCATIONS_SUCCESS,
  REQUEST_PROVINCES,
  REQUEST_PROVINCES_SUCCESS,
  REQUEST_REGISTERS,
  REQUEST_REGISTERS_SUCCESS,
  REQUEST_STATUS_BY_ID,
  REQUEST_SUCCESS,
  UPDATE_INFO,
} from './users.actionTypes';

// @Utils
import { buildErrorsObj } from '../../utils/auth';
import { handleError } from '../../utils/errorHelper';

function* requestWorker({ payload }) {
  try {
    console.log('rw', payload)
    yield put({ type: REQUEST_STARTED });
    const response = yield call(getUsers, payload.params);
    handleError(response);

    yield put({
      type: REQUEST_SUCCESS,
      payload: {
        users: get(response, 'data.result', []),
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestByIdWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(getUserById, payload.usuarioNroDeDocumento, payload.rolCod);
    handleError(response);

    const user = get(response, 'data.result[0]', {});

    if (payload.callback) payload.callback(user);

    yield put({
      type: REQUEST_BY_ID_SUCCESS,
      payload: {
        user,
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestInfoWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const {usuarioId, service, ...rest} = payload;

    const response = yield call(getUserInfo, usuarioId, service, rest);
    handleError(response);

    const userInfo = get(response, 'data.result[0]', {});

    yield put({
      type: REQUEST_INFO_SUCCESS,
      payload: {
        userInfo
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* updateInfoWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(updateUserInfo, payload.params, payload.service);
    handleError(response, payload.callback);

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestStatusByIdWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(getUserStatusById, payload.id);
    handleError(response);

    payload.callback(get(response, 'data.result', []));

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestRegistersWorker() {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(getUserRegisters);
    handleError(response);

    yield put({
      type: REQUEST_REGISTERS_SUCCESS,
      payload: {
        registers: get(response, 'data.result', []),
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestProvincesWorker() {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(getProvinces);
    handleError(response);

    yield put({
      type: REQUEST_PROVINCES_SUCCESS,
      payload: {
        provinces: get(response, 'data.result', []),
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestLocationsWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(getLocations, payload.provinciaId);
    handleError(response);

    yield put({
      type: REQUEST_LOCATIONS_SUCCESS,
      payload: {
        locations: get(response, 'data.result', []),
      }
    });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestWatcher() {
  yield takeLatest(REQUEST, requestWorker);
}

function* requestRegistersWatcher() {
  yield takeLatest(REQUEST_REGISTERS, requestRegistersWorker);
}

function* requestByIdWatcher() {
  yield takeLatest(REQUEST_BY_ID, requestByIdWorker);
}

function* requestInfoWatcher() {
  yield takeLatest(REQUEST_INFO, requestInfoWorker);
}

function* updateInfoWatcher() {
  yield takeLatest(UPDATE_INFO, updateInfoWorker);
}

function* requestStatusByIdWatcher() {
  yield takeLatest(REQUEST_STATUS_BY_ID, requestStatusByIdWorker);
}

function* requestDataAddressWatcher() {
  yield takeLatest(REQUEST_PROVINCES, requestProvincesWorker);
  yield takeLatest(REQUEST_LOCATIONS, requestLocationsWorker);
}

export default {
  requestByIdWatcher,
  requestDataAddressWatcher,
  requestInfoWatcher,
  requestRegistersWatcher,
  requestStatusByIdWatcher,
  requestWatcher,
  updateInfoWatcher,
};



// WEBPACK FOOTER //
// ./src/state/users/users.sagas.js